import { AttributeChip } from './AttributeChip';
import { AttributeFilter } from './AttributeFilter';
import { AttributeProvider } from './AttributeProvider';
import { AttributesInput } from './AttributesInput/AttributesInput';
import { AttributeTextEditor } from './AttributeTextEditor';
import { AttributeValuesInput } from './AttributeValuesInput';

export const Attributes = {
  Chip: AttributeChip,
  Filter: AttributeFilter,
  TextEditor: AttributeTextEditor,
  Input: AttributesInput,
  ValuesInput: AttributeValuesInput,
  Provider: AttributeProvider,
} as const;
